import React, { useState, useEffect } from "react";
import {
  Form,
  Input,
  InputNumber,
  Checkbox,
  Divider,
  Table,
  Select,
  Button,
  Row,
  Col,
  notification,
  Modal
} from "antd";

//import difference from 'lodash/difference';
import { DeleteOutlined, TagOutlined, PlusOutlined } from "@ant-design/icons";
import moment from "moment";
// import { getCoursesActiveApi, getCourseApi } from "../../../../api/course"; //getCourseApi
import { getStudentsByCourseApi } from "../../../../api/inscription";
import { addAbsenceApi } from "../../../../api/absence";
import { getAccessToken } from "../../../../api/auth";
import { formatDateCalendar } from "../../../../utils/formatDate";
import { getStateCoursesActiveApi } from "../../../../api/stateCourse";

import "./AddCourseAbsenceForm.scss";

export default function AddCourseAbsenceForm(props) {
  const { course, setIsVisibleModal, setReloadAbsences } = props;
  const [courseData, setCourseData] = useState({});
  const [listCoursesActive, setListCoursesActive] = useState([]);
  const [listStudentsCourse, setListStudentsCourse] = useState([]);
  const [listStudentsAbsences, setListStudentsAbsences] = useState([]);
  // const [listStateCoursesActive, setListStateCoursesActive] = useState([]);
  const [loading, setLoading] = useState(false);
  const accessToken = getAccessToken();

  useEffect(() => {
    // getCoursesActiveApi(accessToken, true).then((response) => {
    //   setListCoursesActive(response.courses);
    // });
    setCourseData(course);
  }, [course]);

  // useEffect(() => {
  //   getStateCoursesActiveApi(accessToken, true).then((response) => {
  //     setListStateCoursesActive(response.stateCourses);
  //   });
  // }, []);

  useEffect(() => {
    let isMounted=true;
    if (course) {
      getStudentsByCourseApi(accessToken, course._id).then((response) => {
        if(isMounted){
          setListStudentsCourse(response.students);
        }
      });
    }
    return ()=>{
      isMounted=false;
    }
  }, [course]);

  const [inputs, setInputs] = useState({
    course: course ? course._id : null,
    date: formatDateCalendar(moment()),
  });

  const isFormValid = (e) => {
    let errorExists = false;
    // console.log(inputs);
    if (!inputs.course || !inputs.date) {
      notification["error"]({
        message: "Obligatorios: curso y fecha.",
      });
      errorExists = true;
    } else if (listStudentsAbsences.length === 0) {
      notification["error"]({
        message: "Debe seleccionar algún estudiante.",
      });
      errorExists = true;
    }
    return errorExists;
  };

  const addAbsence = async (e) => {
    e.preventDefault();
    if (!isFormValid()) {
      setLoading(true);
      const accessToken = getAccessToken();
      inputs.students = listStudentsAbsences;
      await addAbsenceApi(accessToken, inputs)
        .then(async (response) => {
          if (
            response === "ERR_CONNECTION_REFUSED" ||
            response === "Failed to fetch" ||
            response === undefined
          ) {
            notification["error"]({
              message: "Servidor caido",
            });
            setLoading(false);
          } else if (response.code !== 200) {
            notification["error"]({
              message: response.message,
            });
            setReloadAbsences(true);
            setLoading(false);
          } else {
            notification["success"]({
              message: "Inasistencia creada",
            });
              setReloadAbsences(true);
              setIsVisibleModal(false);
              setLoading(false);
          }
          // setReloadAbsences(true);
        })
        .catch((err) => {
          notification["error"]({
            message: err,
          });
          setLoading(false);
        });
    }
  };

  return (
    <div className="add-absence-form">
      <AddForm
        inputs={inputs}
        setInputs={setInputs}
        course={course}
        courseData={courseData}
        // listCoursesActive={listCoursesActive}
        listStudentsCourse={listStudentsCourse}
        setListStudentsCourse={setListStudentsCourse}
        listStudentsAbsences={listStudentsAbsences}
        setListStudentsAbsences={setListStudentsAbsences}
        addAbsence={addAbsence}
        accessToken={accessToken}
        loading={loading}
      />
    </div>
  );
}

function AddForm(props) {
  const {
    inputs,
    setInputs,
    addAbsence,
    //course,
    courseData,
    // listCoursesActive,
    listStudentsCourse,
    setListStudentsCourse,
    listStudentsAbsences,
    setListStudentsAbsences,
    accessToken,
    loading
  } = props;
  const { Option } = Select;

  useEffect(() => {
    if (inputs.course) {
      getStudentsByCourseApi(accessToken, inputs.course).then((response) => {
        setListStudentsCourse(response.students);
      });
    }
  }, [inputs.course]);

  useEffect(() => {
    if (inputs.course) {
      setListStudentsAbsences([]);
    }
  }, [inputs.course]);

  const addStudents = (e) => {
    e.preventDefault();
    if (inputs.student) {
      let result = listStudentsCourse.filter((i) => i._id === inputs.student);
      if (result !== "undefined") {
        if (
          !listStudentsAbsences.filter(
            (i) => i.student === result[0].student._id
          ).length > 0
        ) {
          const newData = {
            student: result[0].student._id,
            studentData: result[0].student,
            justify: false,
          };
          setListStudentsAbsences([...listStudentsAbsences, newData]);
          setInputs({ ...inputs, student: null });
        } else {
          notification["error"]({
            message: "El estudiante ya se encuentra seleccionado",
          });
        }
      }
    } else {
      notification["error"]({
        message: "Debe elegir al menos un estudiante",
      });
    }
  };

  return (
    <Form className="form-add" onSubmit={addAbsence}>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col span={8}>
          <label className="control-label">
            <span className="control-required">*</span>Código
          </label>
          <Form.Item>
            <InputNumber
              prefix={<TagOutlined />}
              placeholder="Automático"
              value={inputs.course_code}
              onChange={(e) => setInputs({ ...inputs, absence_code: e })}
              style={{ width: "100%" }}
              disabled={true}
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <label className="control-label">
            <span className="control-required">*</span> Fecha
          </label>
          <Form.Item>
            <Input
              // prefix={<CalendarOutlined/>}
              type="date"
              placeholder="Fecha "
              value={inputs.date}
              onChange={(e) => setInputs({ ...inputs, date: e.target.value })}
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <label className="control-label">
            <span className="control-required">*</span> Curso
          </label>
          <Form.Item>
          <Input
              type="text"
              placeholder="Curso "
              value={courseData? courseData.name : null}
              disabled={true}
            />
            {/* <Select
              //prefix={<DollarCircleOutlined />}
              value={inputs.course}
              onChange={(e) => setInputs({ ...inputs, course: e })}
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              disabled={true}
            >  {listCoursesActive
                ? listCoursesActive.map((course) => {
                    return <Option key={course._id}>{course.name}</Option>;
                  })
                : null} *
             </Select> */}
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col span={16}>
          <label className="control-label">
            <span className="control-required">*</span> Estudiantes Inscriptos
          </label>
          <Form.Item>
            <Select
              showSearch
              placeholder="Seleccione los estudiantes"
              // name="items"
              value={inputs.student}
              onChange={(e) =>
                setInputs({
                  ...inputs,
                  student: e,
                })
              }
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {listStudentsCourse
                ? listStudentsCourse.map((i) => {
                    //console.log(i.student);
                    return (
                      <Option key={i._id}>
                        {i.student.name +
                          " " +
                          i.student.lastname +
                          " (" +
                          (i.student.email ? i.student.email : "") +
                          ") "}
                      </Option>
                    );
                  })
                : "No hay estudiantes disponibles"}
            </Select>
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item>
            <Button
              type="primary"
              className="button-add"
              size="middle"
              onClick={addStudents}
            >
              <PlusOutlined /> Agregar
            </Button>
          </Form.Item>
        </Col>
      </Row>
      <Divider />
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col span={24}>
          <Students
            studentsData={listStudentsAbsences}
            setStudentsData={setListStudentsAbsences}
          />
        </Col>
      </Row>
      <Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          className="btn-submit"
          onClick={addAbsence}
          loading={loading}
        >
          Crear
        </Button>
      </Form.Item>
    </Form>
  );
}

function Students(props) {
  const { studentsData, setStudentsData } = props;

  const showDeleteConfirm = (record) => {
    const d = studentsData.filter((i) => i !== record);
    if (d.length === 0) {
      setStudentsData([]);
    } else {
      setStudentsData(d);
    }
  };

  const changeJustify = (rowIndex, columnKey) => (event) => {
    const newData = [...studentsData];
    newData[rowIndex][columnKey] = event.target.checked;
    setStudentsData(newData);
  };

  //console.log(studentsData);

  const columns = [
    // {
    //   title: "Código",
    //   dataIndex: "studentData",
    //   //render: (studentData, row) =>
    //   //  row.studentData ? row.studentData.student_code : "row",
    //   width: "10%",
    //   editable: false,
    //   render: (studentsData) =>
    //     studentsData? studentsData.student_code : null,
    // },
    {
      title: "Nombre",
      dataIndex: "studentData",
      render: (studentsData) => (studentsData ? studentsData.name : null),
      width: "15%",
      editable: false,
    },
    {
      title: "Apellido",
      dataIndex: "studentData",
      render: (studentsData) => (studentsData ? studentsData.lastname : null),
      width: "15%",
      editable: false,
    },
    {
      title: "E-mail",
      dataIndex: "studentData",
      render: (studentsData) => (studentsData ? studentsData.email : null),
      width: "30%",
      editable: false,
    },
    {
      title: "Justificado",
      dataIndex: "justify",
      render: (value, record, rowIndex) => (
        <Checkbox
          checked={value}
          onChange={changeJustify(rowIndex, "justify")}
        />
      ),
      width: "10%",
      editable: true,
    },
    {
      title: "Acción",
      dataIndex: "operation",
      width: "10%",
      render: (_, record) => {
        return (
          <span>
            <Button
              className="button-item"
              type="danger"
              size="small"
              onClick={(e) => showDeleteConfirm(record)}
            >
              <DeleteOutlined />
            </Button>
          </span>
        );
      },
    },
  ];
  return (
    <Table
      columns={columns}
      dataSource={studentsData}
      scroll={{ y: 250 }}
      rowKey="student"
    />
  );
}
